var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThListSolid = function SvgThListSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6v20h24V6Zm2 2h5v4H6Zm7 0h13v4H13Zm-7 6h5v4H6Zm7 0h13v4H13Zm-7 6h5v4H6Zm7 0h13v4H13Z"
  })));
};
export default SvgThListSolid;